import { useState, useEffect, useRef } from "react";
import { portalLogin, criarSolicitacaoCompra, listarSolicitacoesPortal, listarSubtarefas, mensagensPortal as mensagensPortalApi } from './api/functions';
import SecaoAnexosSolicitacao from './components/SecaoAnexosSolicitacao';

const LOGO_URL = "https://media.base44.com/images/public/692ce8b41b53f8d1d71b7ec7/a124921b8_693263386.jpg";

const BRAND = {
  primary: "#00B4A6",
  secondary: "#007A8C",
  dark: "#004D5C",
  light: "#E6F9F8",
  white: "#FFFFFF",
};

const TIPOS_SOLICITACAO = [
  { value: "cotacao_revenda", label: "Cotação para Revenda", icon: "📋" },
  { value: "compra_revenda", label: "Solicitação de Compra Revenda", icon: "🛒" },
  { value: "compra_uso_consumo", label: "Compra Uso/Consumo", icon: "📦" },
  { value: "divergencia_entrada", label: "Divergência de Entrada", icon: "⚠️" },
  { value: "demanda_geral", label: "Demanda Geral", icon: "📝" },
];

const ETAPAS_POR_TIPO = {
  cotacao_revenda: ["Pendente", "Em Cotação", "Precificação", "Cotação Enviada", "Cotação Concluída"],
  compra_revenda: ["Pendente", "Em Negociação", "Pedido Enviado", "Em Transporte", "Pedido Entregue"],
  compra_uso_consumo: ["Pendente Avaliação", "Cancelada", "Pendente Cotação", "Avaliação Financeira", "Cancelada (Financeiro)", "Finalizar Compra", "Compra Feita", "Entregue"],
  divergencia_entrada: ["Pendente", "Negociar Fornecedor", "Realizar Pré-DANFE", "Pré-DANFE Gerada", "Aguard. Aprovação", "NF Gerada", "Produtos Despachados", "Abatimento Crédito"],
  demanda_geral: ["Pendente Avaliação", "Cancelada", "Pendente Cotação", "Avaliação Financeira", "Cancelada (Financeiro)", "Finalizar Compra", "Compra Feita", "Entregue"],
};

function usePortalAuth() {
  const [usuario, setUsuario] = useState(() => {
    try { return JSON.parse(localStorage.getItem("portal_usuario")); } catch { return null; }
  });
  const login = (u) => { localStorage.setItem("portal_usuario", JSON.stringify(u)); setUsuario(u); };
  const logout = () => { localStorage.removeItem("portal_usuario"); setUsuario(null); };
  return { usuario, login, logout };
}

function Input({ label, value, onChange, type = "text", placeholder, required }) {
  return (
    <div style={{ marginBottom: "16px" }}>
      <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} required={required}
        style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box" }}
        onFocus={e => e.target.style.borderColor = BRAND.primary}
        onBlur={e => e.target.style.borderColor = "#E5E7EB"} />
    </div>
  );
}

function TelaAuth({ onLogin }) {
  const [form, setForm] = useState({ email: "", senha: "" });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro("");
    try {
      const data = await portalLogin({ email: form.email, senha: form.senha, tipo: "solicitante" });
      if (data.success) { onLogin(data.usuario); }
      else { setErro(data.error || "Erro ao processar solicitação"); }
    } catch { setErro("Erro de conexão. Tente novamente."); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: `linear-gradient(135deg, ${BRAND.dark} 0%, ${BRAND.primary} 100%)`, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ background: BRAND.white, borderRadius: "20px", padding: "40px", width: "100%", maxWidth: "420px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <img src={LOGO_URL} alt="IntegraConnect" style={{ height: "80px", marginBottom: "8px" }} onError={e => e.target.style.display = "none"} />
          <h2 style={{ color: BRAND.dark, margin: 0, fontSize: "18px", fontWeight: "700" }}>Portal de Compras</h2>
          <p style={{ color: "#666", margin: "4px 0 0", fontSize: "13px" }}>Solicitações internas · IntegraAiCom</p>
        </div>
        <form onSubmit={handleSubmit}>
          <Input label="E-mail" type="email" value={form.email} onChange={v => setForm({ ...form, email: v })} placeholder="seu@email.com" required />
          <Input label="Senha" type="password" value={form.senha} onChange={v => setForm({ ...form, senha: v })} placeholder="••••••••" required />
          {erro && <div style={{ background: "#fee2e2", color: "#dc2626", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{erro}</div>}
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "13px", background: loading ? "#ccc" : `linear-gradient(135deg, ${BRAND.primary}, ${BRAND.secondary})`, color: BRAND.white, border: "none", borderRadius: "10px", fontWeight: "700", fontSize: "15px", cursor: loading ? "not-allowed" : "pointer" }}>
            {loading ? "Aguarde..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}

function FormularioSolicitacao({ usuario, onSucesso, onCancelar }) {
  const [tipo, setTipo] = useState("");
  const [form, setForm] = useState({ titulo: "", descricao: "", urgencia: "Normal", prazo: "", vendedor: "", orc_valor: "", onde_cotar: "", itens_cotacao: "", num_pedido: "", onde_comprar: "", setor: "", tipo_prazo: "Rotina", tipo_divergencia: "Falta", nf_fiscal: "", regiao: "", cte: "", valor_solicitado: "" });
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");

  const selectStyle = { width: "100%", padding: "11px 14px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "14px", outline: "none", marginBottom: "16px" };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!tipo) { setErro("Selecione o tipo de solicitação"); return; }
    if (!form.valor_solicitado || Number(form.valor_solicitado) <= 0) { setErro("Informe o valor solicitado (R$)"); return; }
    setLoading(true);
    setErro("");
    try {
      const data = await criarSolicitacaoCompra({ tipo, ...form, valor_solicitado: Number(form.valor_solicitado), solicitante_nome: usuario.nome, solicitante_email: usuario.email, empresa_id: usuario.empresa_id || "portal", empresa_nome: usuario.empresa_nome });
      if (data.success) { onSucesso(data.tarefa_id); }
      else { setErro(data.error || "Erro ao criar solicitação"); }
    } catch { setErro("Erro de conexão"); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ background: BRAND.white, borderRadius: "16px", padding: "28px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)" }}>
      <h3 style={{ margin: "0 0 20px", color: BRAND.dark, fontSize: "18px" }}>Nova Solicitação</h3>
      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "8px" }}>Tipo de Solicitação *</label>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "10px" }}>
          {TIPOS_SOLICITACAO.map(t => (
            <button key={t.value} onClick={() => setTipo(t.value)} type="button"
              style={{ padding: "12px", border: `2px solid ${tipo === t.value ? BRAND.primary : "#E5E7EB"}`, borderRadius: "10px", background: tipo === t.value ? BRAND.light : BRAND.white, cursor: "pointer", textAlign: "left" }}>
              <div style={{ fontSize: "20px", marginBottom: "4px" }}>{t.icon}</div>
              <div style={{ fontSize: "12px", fontWeight: "600", color: BRAND.dark }}>{t.label}</div>
            </button>
          ))}
        </div>
      </div>
      <Input label="Título" value={form.titulo} onChange={v => setForm({ ...form, titulo: v })} placeholder="Descreva brevemente" required />
      <Input label="Valor Solicitado (R$) *" type="number" value={form.valor_solicitado} onChange={v => setForm({ ...form, valor_solicitado: v })} placeholder="Ex: 1500.00" required />
      <div style={{ marginBottom: "16px" }}>
        <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Urgência</label>
        <select value={form.urgencia} onChange={e => setForm({ ...form, urgencia: e.target.value })} style={selectStyle}>
          {["Baixa", "Normal", "Alta", "Urgente"].map(u => <option key={u}>{u}</option>)}
        </select>
      </div>
      <Input label="Prazo desejado" type="date" value={form.prazo} onChange={v => setForm({ ...form, prazo: v })} />
      {(tipo === "cotacao_revenda" || tipo === "compra_revenda") && <Input label="Vendedor" value={form.vendedor} onChange={v => setForm({ ...form, vendedor: v })} placeholder="Nome do vendedor" />}
      {tipo === "cotacao_revenda" && (
        <>
          <Input label="Valor do orçamento (R$)" value={form.orc_valor} onChange={v => setForm({ ...form, orc_valor: v })} placeholder="Ex: 5000" />
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Onde cotar?</label>
            <select value={form.onde_cotar} onChange={e => setForm({ ...form, onde_cotar: e.target.value })} style={selectStyle}>
              <option value="">Selecione...</option>
              <option>Indústria</option><option>Praça</option><option>Indústria e Praça</option>
            </select>
          </div>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Itens para cotação</label>
            <textarea value={form.itens_cotacao} onChange={e => setForm({ ...form, itens_cotacao: e.target.value })} placeholder="Liste os itens..." rows={3} style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
          </div>
        </>
      )}
      {tipo === "compra_revenda" && (
        <>
          <Input label="Nº do pedido" value={form.num_pedido} onChange={v => setForm({ ...form, num_pedido: v })} placeholder="Ex: 12345" />
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Onde comprar?</label>
            <select value={form.onde_comprar} onChange={e => setForm({ ...form, onde_comprar: e.target.value })} style={selectStyle}>
              <option value="">Selecione...</option><option>Indústria</option><option>Praça</option>
            </select>
          </div>
        </>
      )}
      {(tipo === "compra_uso_consumo" || tipo === "demanda_geral") && (
        <>
          <Input label="Setor" value={form.setor} onChange={v => setForm({ ...form, setor: v })} placeholder="Ex: Operacional, TI, RH..." />
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Tipo de prazo</label>
            <select value={form.tipo_prazo} onChange={e => setForm({ ...form, tipo_prazo: e.target.value })} style={selectStyle}>
              <option>Rotina</option><option>Emergencial</option>
            </select>
          </div>
        </>
      )}
      {tipo === "divergencia_entrada" && (
        <>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Tipo de divergência</label>
            <select value={form.tipo_divergencia} onChange={e => setForm({ ...form, tipo_divergencia: e.target.value })} style={selectStyle}>
              <option>Falta</option><option>Avaria</option>
            </select>
          </div>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Região</label>
            <select value={form.regiao} onChange={e => setForm({ ...form, regiao: e.target.value })} style={selectStyle}>
              <option value="">Selecione...</option><option>Indústria</option><option>Praça</option>
            </select>
          </div>
          <Input label="NF Fiscal" value={form.nf_fiscal} onChange={v => setForm({ ...form, nf_fiscal: v })} placeholder="Número da nota fiscal" />
          <Input label="CTe" value={form.cte} onChange={v => setForm({ ...form, cte: v })} placeholder="Código do CTe" />
        </>
      )}
      <div style={{ marginBottom: "16px" }}>
        <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: BRAND.dark, marginBottom: "6px" }}>Descrição detalhada *</label>
        <textarea value={form.descricao} onChange={e => setForm({ ...form, descricao: e.target.value })} placeholder="Descreva com detalhes..." required rows={4} style={{ width: "100%", padding: "11px 14px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "14px", outline: "none", boxSizing: "border-box", resize: "vertical" }} />
      </div>
      {erro && <div style={{ background: "#fee2e2", color: "#dc2626", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", marginBottom: "16px" }}>{erro}</div>}
      <div style={{ display: "flex", gap: "12px" }}>
        <button type="button" onClick={onCancelar} style={{ flex: 1, padding: "12px", border: `1.5px solid ${BRAND.primary}`, borderRadius: "10px", background: "transparent", color: BRAND.primary, fontWeight: "600", cursor: "pointer", fontSize: "14px" }}>Cancelar</button>
        <button type="button" onClick={handleSubmit} disabled={loading} style={{ flex: 2, padding: "12px", background: loading ? "#ccc" : `linear-gradient(135deg, ${BRAND.primary}, ${BRAND.secondary})`, color: BRAND.white, border: "none", borderRadius: "10px", fontWeight: "700", cursor: loading ? "not-allowed" : "pointer", fontSize: "14px" }}>
          {loading ? "Enviando..." : "Enviar Solicitação"}
        </button>
      </div>
    </div>
  );
}

function ChatPortal({ solicitacaoId, usuario }) {
  const [mensagens, setMensagens] = useState([]);
  const [texto, setTexto] = useState('');
  const [enviando, setEnviando] = useState(false);
  const bottomRef = useRef(null);
  const carregandoRef = useRef(false);
  const mountedRef = useRef(true);
  const intervalRef = useRef(null);

  const buscar = async () => {
    if (!solicitacaoId || carregandoRef.current || !mountedRef.current) return;
    carregandoRef.current = true;
    try {
      const data = await mensagensPortalApi({ acao: 'listar', solicitacao_id: solicitacaoId });
      if (data?.success && mountedRef.current) setMensagens(data.mensagens || []);
    } catch {}
    finally { carregandoRef.current = false; }
  };

  useEffect(() => {
    mountedRef.current = true;
    if (!solicitacaoId) return;
    buscar();
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(buscar, 30000);
    return () => {
      mountedRef.current = false;
      carregandoRef.current = false;
      if (intervalRef.current) { clearInterval(intervalRef.current); intervalRef.current = null; }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solicitacaoId]);

  useEffect(() => { bottomRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [mensagens]);

  const enviar = async () => {
    if (!texto.trim() || enviando) return;
    setEnviando(true);
    try {
      await mensagensPortalApi({ acao: 'enviar', solicitacao_id: solicitacaoId, tarefa_id: solicitacaoId, autor_nome: usuario?.nome || 'Solicitante', autor_tipo: 'solicitante', mensagem: texto.trim() });
      setTexto('');
      await buscar();
    } catch {}
    finally { setEnviando(false); }
  };

  const handleKey = (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); enviar(); } };

  return (
    <div style={{ border: '1.5px solid #E5E7EB', borderRadius: '10px', overflow: 'hidden', marginTop: '16px', maxHeight: '350px' }}>
      <div style={{ background: BRAND.light, padding: '8px 12px', fontWeight: '700', fontSize: '12px', color: BRAND.dark, borderBottom: '1px solid #E5E7EB' }}>
        💬 Chat com a equipe ({mensagens.length})
      </div>
      <div style={{ padding: '8px 12px', height: '200px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '8px', background: '#FAFAFA' }}>
        {mensagens.length === 0 && <p style={{ textAlign: 'center', color: '#aaa', fontSize: '12px', padding: '16px 0' }}>Nenhuma mensagem ainda.</p>}
        {mensagens.map(msg => {
          const isMeu = msg.autor_tipo === 'solicitante';
          return (
            <div key={msg.id} style={{ display: 'flex', flexDirection: 'column', alignItems: isMeu ? 'flex-end' : 'flex-start' }}>
              <div style={{ maxWidth: '75%', padding: '7px 11px', borderRadius: isMeu ? '12px 12px 3px 12px' : '12px 12px 12px 3px', background: isMeu ? BRAND.primary : '#FFFFFF', color: isMeu ? '#fff' : '#333', fontSize: '12px', lineHeight: '1.45', boxShadow: '0 1px 2px rgba(0,0,0,0.07)', border: isMeu ? 'none' : '1px solid #E5E7EB' }}>
                {msg.mensagem}
              </div>
              <span style={{ fontSize: '10px', color: '#bbb', marginTop: '2px' }}>{msg.autor_nome} · {new Date(msg.created_date).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}</span>
            </div>
          );
        })}
        <div ref={bottomRef} />
      </div>
      <div style={{ display: 'flex', gap: '6px', padding: '8px 12px', borderTop: '1px solid #E5E7EB', background: '#fff', alignItems: 'center' }}>
        <input value={texto} onChange={e => setTexto(e.target.value)} onKeyDown={handleKey} placeholder="Escreva uma mensagem..."
          style={{ flex: 1, padding: '7px 10px', border: '1.5px solid #E5E7EB', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box' }}
          onFocus={e => e.target.style.borderColor = BRAND.primary} onBlur={e => e.target.style.borderColor = '#E5E7EB'} />
        <button onClick={enviar} disabled={!texto.trim() || enviando}
          style={{ padding: '7px 14px', background: !texto.trim() || enviando ? '#ccc' : `linear-gradient(135deg, ${BRAND.primary}, ${BRAND.secondary})`, color: '#fff', border: 'none', borderRadius: '8px', fontWeight: '700', cursor: !texto.trim() || enviando ? 'not-allowed' : 'pointer', fontSize: '14px' }}>➤</button>
      </div>
    </div>
  );
}

function LinhaTempo({ tarefa, onFechar, usuario }) {
  const [subtarefas, setSubtarefas] = useState([]);
  const [loadingSub, setLoadingSub] = useState(true);
  const tipoKey = tarefa.tipo_solicitacao || tarefa.tipo || "";
  const etapas = ETAPAS_POR_TIPO[tipoKey] || [];
  const statusAtual = tarefa.status || "";
  const etapaAtualIdx = etapas.indexOf(statusAtual);

  useEffect(() => {
    const carregar = async () => {
      setLoadingSub(true);
      try {
        const data = await listarSubtarefas({ tarefa_id: tarefa.id });
        setSubtarefas(data.subtarefas || []);
      } catch { setSubtarefas([]); }
      finally { setLoadingSub(false); }
    };
    carregar();
  }, [tarefa.id]);

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ background: BRAND.white, borderRadius: "20px", width: "100%", maxWidth: "560px", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ padding: "24px", borderBottom: "1px solid #E5E7EB", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
          <div>
            <h3 style={{ margin: 0, color: BRAND.dark, fontSize: "17px", fontWeight: "700" }}>{tarefa.titulo}</h3>
            <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#666" }}>
              {TIPOS_SOLICITACAO.find(t => t.value === tipoKey)?.label || tipoKey} · {new Date(tarefa.created_date).toLocaleDateString("pt-BR")}
            </p>
          </div>
          <button onClick={onFechar} style={{ background: "none", border: "none", fontSize: "22px", cursor: "pointer", color: "#999", lineHeight: 1 }}>×</button>
        </div>
        <div style={{ padding: "24px" }}>
          <div style={{ marginBottom: "24px", display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
            <span style={{ background: BRAND.light, color: BRAND.primary, padding: "6px 14px", borderRadius: "20px", fontSize: "13px", fontWeight: "600", border: `1px solid ${BRAND.primary}` }}>
              Status atual: {statusAtual || "—"}
            </span>
            {tarefa.aprovacao_status === "Aprovada" ? (
              <span style={{ fontSize: "13px", fontWeight: "700", color: "#166534", background: "#D1FAE5", padding: "6px 16px", borderRadius: "20px", border: "1.5px solid #6EE7B7" }}>✅ Aprovada{tarefa.aprovado_por_nome && <span style={{ fontWeight: "400", fontSize: "12px", marginLeft: "6px" }}>por {tarefa.aprovado_por_nome}</span>}</span>
            ) : tarefa.aprovacao_status === "Não Aprovada" ? (
              <span style={{ fontSize: "13px", fontWeight: "700", color: "#991B1B", background: "#FEE2E2", padding: "6px 16px", borderRadius: "20px", border: "1.5px solid #FCA5A5" }}>❌ Não Aprovada{tarefa.aprovado_por_nome && <span style={{ fontWeight: "400", fontSize: "12px", marginLeft: "6px" }}>por {tarefa.aprovado_por_nome}</span>}</span>
            ) : (
              <span style={{ fontSize: "13px", fontWeight: "700", color: "#92400E", background: "#FEF3C7", padding: "6px 16px", borderRadius: "20px", border: "1.5px solid #FDE68A" }}>⏳ Aguardando Aprovação</span>
            )}
          </div>
          {etapas.length > 0 && (
            <div style={{ marginBottom: "24px" }}>
              <h4 style={{ margin: "0 0 16px", color: BRAND.dark, fontSize: "14px", fontWeight: "600", textTransform: "uppercase" }}>Progresso</h4>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                {etapas.map((etapa, i) => {
                  const feito = i <= etapaAtualIdx && etapaAtualIdx >= 0;
                  const atual = i === etapaAtualIdx;
                  return (
                    <div key={etapa} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div style={{ width: "32px", height: "32px", borderRadius: "50%", background: feito ? BRAND.primary : "#E5E7EB", border: `2px solid ${feito ? BRAND.secondary : "#D1D5DB"}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", color: feito ? BRAND.white : "#9CA3AF", fontWeight: "700", flexShrink: 0 }}>
                        {feito ? "✓" : i + 1}
                      </div>
                      <span style={{ fontSize: "14px", color: feito ? BRAND.dark : "#9CA3AF", fontWeight: atual ? "700" : "400" }}>{etapa}</span>
                      {atual && <span style={{ background: BRAND.primary, color: BRAND.white, fontSize: "10px", padding: "2px 8px", borderRadius: "10px", fontWeight: "600" }}>Atual</span>}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          <div style={{ background: BRAND.light, borderRadius: "12px", padding: "16px", marginBottom: "20px" }}>
            <h4 style={{ margin: "0 0 12px", color: BRAND.dark, fontSize: "13px", fontWeight: "600", textTransform: "uppercase" }}>Detalhes</h4>
            {tarefa.descricao && <p style={{ margin: "0 0 10px", fontSize: "14px", color: "#444" }}>{tarefa.descricao}</p>}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
              {tarefa.prioridade && <div><span style={{ fontSize: "11px", color: "#888" }}>Urgência</span><p style={{ margin: 0, fontSize: "13px", fontWeight: "600", color: BRAND.dark }}>{tarefa.prioridade}</p></div>}
              {tarefa.prazo && <div><span style={{ fontSize: "11px", color: "#888" }}>Prazo</span><p style={{ margin: 0, fontSize: "13px", fontWeight: "600", color: BRAND.dark }}>{new Date(tarefa.prazo).toLocaleDateString("pt-BR")}</p></div>}
            </div>
          </div>
          {loadingSub ? <p style={{ color: "#888", fontSize: "13px" }}>Carregando etapas...</p> : subtarefas.length > 0 && (
            <div>
              <h4 style={{ margin: "0 0 12px", color: BRAND.dark, fontSize: "13px", fontWeight: "600", textTransform: "uppercase" }}>Etapas do processo</h4>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {subtarefas.map(sub => (
                  <div key={sub.id} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", borderRadius: "8px", background: sub.concluida ? "#f0fdf4" : "#F9FAFB", border: `1px solid ${sub.concluida ? "#86efac" : "#E5E7EB"}` }}>
                    <div style={{ width: "20px", height: "20px", borderRadius: "50%", background: sub.concluida ? "#22c55e" : "#E5E7EB", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", color: sub.concluida ? BRAND.white : "#9CA3AF", flexShrink: 0 }}>{sub.concluida ? "✓" : ""}</div>
                    <span style={{ fontSize: "13px", color: sub.concluida ? "#166534" : "#374151" }}>{sub.titulo}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          <ChatPortal solicitacaoId={tarefa.id} usuario={usuario} />
          <SecaoAnexosSolicitacao tarefa={tarefa} podeAdicionar={true} usuarioEmail={usuario?.email} onAnexoAdicionado={() => console.log("Anexo adicionado")} />
        </div>
      </div>
    </div>
  );
}

function CardSolicitacao({ tarefa, onVerDetalhes }) {
  const tipoInfo = TIPOS_SOLICITACAO.find(t => t.value === (tarefa.tipo_solicitacao || tarefa.tipo)) || {};
  const urgenciaCor = { Urgente: "#ef4444", Alta: "#f97316", Normal: "#3b82f6", Baixa: "#6b7280" };
  return (
    <div style={{ background: BRAND.white, borderRadius: "14px", padding: "18px 20px", boxShadow: "0 2px 8px rgba(0,0,0,0.07)", border: "1px solid #F3F4F6", cursor: "default" }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,180,166,0.15)"}
      onMouseLeave={e => e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.07)"}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "10px" }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
            <span style={{ fontSize: "18px" }}>{tipoInfo.icon || "📄"}</span>
            <span style={{ fontSize: "12px", color: BRAND.primary, fontWeight: "600", background: BRAND.light, padding: "2px 10px", borderRadius: "10px" }}>{tipoInfo.label || tarefa.tipo}</span>
          </div>
          <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: BRAND.dark }}>{tarefa.titulo}</h4>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "12px", color: "#888", marginBottom: "4px" }}>{new Date(tarefa.created_date).toLocaleDateString("pt-BR")}</div>
          {tarefa.prioridade && <span style={{ fontSize: "11px", fontWeight: "600", color: urgenciaCor[tarefa.prioridade] || "#666", background: `${urgenciaCor[tarefa.prioridade]}15`, padding: "2px 8px", borderRadius: "8px" }}>{tarefa.prioridade}</span>}
        </div>
      </div>
      {tarefa.descricao && <p style={{ margin: "0 0 12px", fontSize: "13px", color: "#666", lineHeight: "1.5", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{tarefa.descricao}</p>}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          <span style={{ fontSize: "12px", fontWeight: "600", color: BRAND.primary, background: BRAND.light, padding: "4px 12px", borderRadius: "10px", border: `1px solid ${BRAND.primary}40` }}>{tarefa.status || "Pendente"}</span>
          {tarefa.aprovacao_status === "Aprovada" ? (
            <span style={{ fontSize: "11px", fontWeight: "700", color: "#166534", background: "#D1FAE5", padding: "3px 10px", borderRadius: "10px", border: "1px solid #6EE7B7", display: "inline-block" }}>✅ Aprovada</span>
          ) : tarefa.aprovacao_status === "Não Aprovada" ? (
            <span style={{ fontSize: "11px", fontWeight: "700", color: "#991B1B", background: "#FEE2E2", padding: "3px 10px", borderRadius: "10px", border: "1px solid #FCA5A5", display: "inline-block" }}>❌ Não Aprovada</span>
          ) : (
            <span style={{ fontSize: "11px", fontWeight: "700", color: "#92400E", background: "#FEF3C7", padding: "3px 10px", borderRadius: "10px", border: "1px solid #FDE68A", display: "inline-block" }}>⏳ Aguardando Aprovação</span>
          )}
        </div>
        <button onClick={() => onVerDetalhes(tarefa)} style={{ background: "none", border: "none", color: BRAND.primary, fontWeight: "600", fontSize: "13px", cursor: "pointer" }}>Acompanhar →</button>
      </div>
    </div>
  );
}

function Dashboard({ usuario, onLogout }) {
  const [tela, setTela] = useState("lista");
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tarefaSelecionada, setTarefaSelecionada] = useState(null);
  const [filtroTipo, setFiltroTipo] = useState("todos");
  const [buscaNome, setBuscaNome] = useState("");
  const [filtroStatus, setFiltroStatus] = useState("todos");
  const [filtroUrgencia, setFiltroUrgencia] = useState("todos");
  const [filtroDataDe, setFiltroDataDe] = useState("");
  const [filtroDataAte, setFiltroDataAte] = useState("");
  const [mostrarFiltroAvancado, setMostrarFiltroAvancado] = useState(false);
  const carregandoSolicRef = useRef(false);

  const carregarSolicitacoes = async () => {
    if (carregandoSolicRef.current) return;
    carregandoSolicRef.current = true;
    setLoading(true);
    try {
      const data = await listarSolicitacoesPortal({ solicitante_email: usuario.email, empresa_id: usuario.empresa_id });
      setSolicitacoes(data.tarefas || []);
    } catch { setSolicitacoes([]); }
    finally { setLoading(false); carregandoSolicRef.current = false; }
  };

  useEffect(() => { carregarSolicitacoes(); }, []);

  const solicitacoesFiltradas = solicitacoes.filter(s => {
    if (filtroTipo !== "todos" && (s.tipo_solicitacao || s.tipo) !== filtroTipo) return false;
    if (buscaNome && !((s.titulo || s.title || "").toLowerCase().includes(buscaNome.toLowerCase()))) return false;
    if (filtroStatus !== "todos") {
      const st = (s.status || "").toLowerCase();
      if (filtroStatus === "pendente" && !st.includes("pendente")) return false;
      if (filtroStatus === "andamento" && (st.includes("pendente") || st.includes("entregue") || st.includes("concluí") || st.includes("cancelad"))) return false;
      if (filtroStatus === "concluida" && !st.includes("entregue") && !st.includes("concluí")) return false;
      if (filtroStatus === "cancelada" && !st.includes("cancelad")) return false;
    }
    if (filtroUrgencia !== "todos" && (s.urgencia || "").toLowerCase() !== filtroUrgencia.toLowerCase()) return false;
    if (filtroDataDe && s.created_date && new Date(s.created_date) < new Date(filtroDataDe)) return false;
    if (filtroDataAte && s.created_date && new Date(s.created_date) > new Date(filtroDataAte + "T23:59:59")) return false;
    return true;
  });
  const stats = [
    { label: "Total", valor: solicitacoes.length, cor: BRAND.primary },
    { label: "Pendentes", valor: solicitacoes.filter(s => (s.status || "").includes("Pendente")).length, cor: "#f59e0b" },
    { label: "Em Andamento", valor: solicitacoes.filter(s => s.status && !s.status.includes("Pendente") && !s.status.includes("Entregue") && !s.status.includes("Concluída") && !s.status.includes("Cancelada")).length, cor: "#3b82f6" },
    { label: "Concluídas", valor: solicitacoes.filter(s => s.status && (s.status.includes("Entregue") || s.status.includes("Concluída"))).length, cor: "#22c55e" },
  ];

  return (
    <div style={{ minHeight: "100vh", background: "#F0FAFA" }}>
      <div style={{ background: `linear-gradient(135deg, ${BRAND.dark}, ${BRAND.primary})`, padding: "0 24px", boxShadow: "0 2px 12px rgba(0,0,0,0.15)" }}>
        <div style={{ maxWidth: "900px", margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", height: "64px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <img src={LOGO_URL} alt="Logo" style={{ height: "48px", width: "48px", objectFit: "contain", borderRadius: "8px" }} onError={e => e.target.style.display = "none"} />
            <div>
              <div style={{ color: BRAND.white, fontWeight: "700", fontSize: "15px", lineHeight: 1 }}>Portal de Compras</div>
              <div style={{ color: "rgba(255,255,255,0.7)", fontSize: "12px" }}>Olá, {usuario.nome}</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <button onClick={() => { setTela("lista"); carregarSolicitacoes(); }} style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: BRAND.white, padding: "7px 14px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>Minhas Solicitações</button>
            <button onClick={() => setTela("nova")} style={{ background: BRAND.white, border: "none", color: BRAND.primary, padding: "7px 16px", borderRadius: "8px", cursor: "pointer", fontSize: "13px", fontWeight: "700" }}>+ Nova</button>
            <button onClick={onLogout} style={{ background: "none", border: "1px solid rgba(255,255,255,0.3)", color: "rgba(255,255,255,0.7)", padding: "7px 12px", borderRadius: "8px", cursor: "pointer", fontSize: "12px" }}>Sair</button>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "24px" }}>
        {tela === "nova" ? (
          <FormularioSolicitacao usuario={usuario} onSucesso={() => { setTela("lista"); carregarSolicitacoes(); }} onCancelar={() => setTela("lista")} />
        ) : (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "14px", marginBottom: "24px" }}>
              {stats.map(s => (
                <div key={s.label} style={{ background: BRAND.white, borderRadius: "12px", padding: "16px", textAlign: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", borderTop: `3px solid ${s.cor}` }}>
                  <div style={{ fontSize: "28px", fontWeight: "800", color: s.cor }}>{s.valor}</div>
                  <div style={{ fontSize: "12px", color: "#888", fontWeight: "500" }}>{s.label}</div>
                </div>
              ))}
            </div>
            {/* Busca por nome */}
            <div style={{ marginBottom: "14px" }}>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <input
                  type="text"
                  placeholder="🔍 Pesquisar por nome..."
                  value={buscaNome}
                  onChange={e => setBuscaNome(e.target.value)}
                  style={{ flex: 1, padding: "9px 14px", border: "1.5px solid #E5E7EB", borderRadius: "10px", fontSize: "14px", outline: "none", boxSizing: "border-box" }}
                  onFocus={e => e.target.style.borderColor = BRAND.primary}
                  onBlur={e => e.target.style.borderColor = "#E5E7EB"}
                />
                <button
                  onClick={() => setMostrarFiltroAvancado(v => !v)}
                  style={{ padding: "9px 16px", borderRadius: "10px", border: `1.5px solid ${mostrarFiltroAvancado ? BRAND.primary : "#D1D5DB"}`, background: mostrarFiltroAvancado ? BRAND.light : "#fff", color: mostrarFiltroAvancado ? BRAND.primary : "#555", fontSize: "13px", fontWeight: "600", cursor: "pointer", whiteSpace: "nowrap" }}
                >
                  ⚙️ Filtro Avançado {mostrarFiltroAvancado ? "▲" : "▼"}
                </button>
                {(filtroStatus !== "todos" || filtroUrgencia !== "todos" || filtroDataDe || filtroDataAte) && (
                  <button
                    onClick={() => { setFiltroStatus("todos"); setFiltroUrgencia("todos"); setFiltroDataDe(""); setFiltroDataAte(""); }}
                    style={{ padding: "9px 12px", borderRadius: "10px", border: "1.5px solid #fca5a5", background: "#fef2f2", color: "#dc2626", fontSize: "12px", fontWeight: "600", cursor: "pointer", whiteSpace: "nowrap" }}
                  >
                    ✕ Limpar
                  </button>
                )}
              </div>
              {mostrarFiltroAvancado && (
                <div style={{ background: "#fff", border: "1.5px solid #E5E7EB", borderRadius: "12px", padding: "16px", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "12px", marginTop: "10px" }}>
                  <div>
                    <label style={{ fontSize: "12px", fontWeight: "600", color: BRAND.dark, display: "block", marginBottom: "4px" }}>Status</label>
                    <select value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)} style={{ width: "100%", padding: "8px 10px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "13px" }}>
                      <option value="todos">Todos</option>
                      <option value="pendente">Pendentes</option>
                      <option value="andamento">Em Andamento</option>
                      <option value="concluida">Concluídas</option>
                      <option value="cancelada">Canceladas</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: "12px", fontWeight: "600", color: BRAND.dark, display: "block", marginBottom: "4px" }}>Urgência</label>
                    <select value={filtroUrgencia} onChange={e => setFiltroUrgencia(e.target.value)} style={{ width: "100%", padding: "8px 10px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "13px" }}>
                      <option value="todos">Todas</option>
                      <option value="Baixa">Baixa</option>
                      <option value="Normal">Normal</option>
                      <option value="Alta">Alta</option>
                      <option value="Urgente">Urgente</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize: "12px", fontWeight: "600", color: BRAND.dark, display: "block", marginBottom: "4px" }}>Data de</label>
                    <input type="date" value={filtroDataDe} onChange={e => setFiltroDataDe(e.target.value)} style={{ width: "100%", padding: "8px 10px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "13px" }} />
                  </div>
                  <div>
                    <label style={{ fontSize: "12px", fontWeight: "600", color: BRAND.dark, display: "block", marginBottom: "4px" }}>Data até</label>
                    <input type="date" value={filtroDataAte} onChange={e => setFiltroDataAte(e.target.value)} style={{ width: "100%", padding: "8px 10px", border: "1.5px solid #E5E7EB", borderRadius: "8px", fontSize: "13px" }} />
                  </div>
                </div>
              )}
            </div>

            {/* Filtros por tipo */}
            <div style={{ display: "flex", gap: "8px", marginBottom: "20px", flexWrap: "wrap" }}>
              <button onClick={() => setFiltroTipo("todos")} style={{ padding: "6px 14px", borderRadius: "20px", border: `1.5px solid ${filtroTipo === "todos" ? BRAND.primary : "#D1D5DB"}`, background: filtroTipo === "todos" ? BRAND.primary : BRAND.white, color: filtroTipo === "todos" ? BRAND.white : "#555", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}>Todos</button>
              {TIPOS_SOLICITACAO.map(t => (
                <button key={t.value} onClick={() => setFiltroTipo(t.value)} style={{ padding: "6px 14px", borderRadius: "20px", border: `1.5px solid ${filtroTipo === t.value ? BRAND.primary : "#D1D5DB"}`, background: filtroTipo === t.value ? BRAND.primary : BRAND.white, color: filtroTipo === t.value ? BRAND.white : "#555", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}>
                  {t.icon} {t.label}
                </button>
              ))}
            </div>
            {loading ? (
              <div style={{ textAlign: "center", padding: "60px 0" }}>
                <div style={{ width: "36px", height: "36px", border: `3px solid ${BRAND.light}`, borderTop: `3px solid ${BRAND.primary}`, borderRadius: "50%", animation: "spin 0.8s linear infinite", margin: "0 auto 16px" }} />
                <p style={{ color: "#888", fontSize: "14px" }}>Carregando...</p>
              </div>
            ) : solicitacoesFiltradas.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px 20px", background: BRAND.white, borderRadius: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                <div style={{ fontSize: "48px", marginBottom: "12px" }}>📋</div>
                <h3 style={{ color: BRAND.dark, marginBottom: "8px" }}>{solicitacoes.length === 0 ? "Nenhuma solicitação ainda" : "Sem resultados para este filtro"}</h3>
                {solicitacoes.length === 0 && (
                  <button onClick={() => setTela("nova")} style={{ background: `linear-gradient(135deg, ${BRAND.primary}, ${BRAND.secondary})`, color: BRAND.white, border: "none", padding: "12px 24px", borderRadius: "10px", fontWeight: "700", cursor: "pointer", fontSize: "14px", marginTop: "8px" }}>Criar primeira solicitação</button>
                )}
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {solicitacoesFiltradas.map(t => <CardSolicitacao key={t.id} tarefa={t} onVerDetalhes={setTarefaSelecionada} />)}
              </div>
            )}
          </>
        )}
      </div>
      {tarefaSelecionada && <LinhaTempo tarefa={tarefaSelecionada} onFechar={() => setTarefaSelecionada(null)} usuario={usuario} />}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default function PortalCompras() {
  const { usuario, login, logout } = usePortalAuth();
  if (!usuario) return <TelaAuth onLogin={login} />;
  return <Dashboard usuario={usuario} onLogout={logout} />;
}

